import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/icons/mcd-bag.svg")